/* TOOMINI Atelier: galeria, warianty, zestawy, przyklejony przycisk, suwak rozkładania */
(function () {
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PLN';
    try { return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: cur }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' zł'; }
  }
  function units(v) { var m = /(\d+)/.exec(v || ''); return m ? parseInt(m[1], 10) : 1; }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }

  function initGallery(root) {
    var track = root.querySelector('[data-ta-track]');
    if (!track) return null;
    var slides = $$(track, '[data-ta-slide]');
    var thumbs = $$(root, '[data-ta-thumb]');
    var dots = $$(root, '[data-ta-dot]');
    var prev = root.querySelector('[data-ta-prev]'), next = root.querySelector('[data-ta-next]');
    var count = root.querySelector('[data-ta-count]');
    var cur = 0;
    function mark(i) {
      cur = i;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      if (count) count.textContent = i + 1;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    function go(i, smooth) {
      if (i < 0 || i >= slides.length) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      mark(i);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k, true); }); });
    if (prev) prev.addEventListener('click', function () { go(cur - 1, true); });
    if (next) next.addEventListener('click', function () { go(cur + 1, true); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k, true); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1, true); }
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        mark(i);
        slides.forEach(function (s, k) { if (k !== i) $$(s, 'video').forEach(function (v) { try { v.pause(); } catch (e) {} }); });
      });
    });
    return {
      toMedia: function (id) {
        for (var k = 0; k < slides.length; k++) { if (slides[k].getAttribute('data-media-id') === String(id)) { go(k, true); return; } }
      }
    };
  }

  function initBuy(root) {
    if (root.dataset.taReady) return;
    root.dataset.taReady = '1';
    var gallery = initGallery(root);
    var jsonEl = root.querySelector('[data-ta-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var V = data.variants;
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form.querySelector('[name="id"]');
    var btn = form.querySelector('[type="submit"]');
    var btnText = btn.querySelector('span');
    var fields = $$(root, '[data-ta-option]');
    var sticky = root.querySelector('[data-ta-sticky]');

    function sel() { return fields.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; }); }
    function find(o) {
      for (var k = 0; k < V.length; k++) {
        var ok = true;
        for (var j = 0; j < o.length; j++) { if (V[k].options[j] !== o[j]) { ok = false; break; } }
        if (ok) return V[k];
      }
      return null;
    }
    function cheapest(k, val) {
      var b = null;
      V.forEach(function (v) { if (v.options[k] === val && (!b || v.price < b.price)) b = v; });
      return b;
    }
    function set(s, text) { $$(root, s).forEach(function (e) { e.textContent = text; }); }
    function show(s, on) { $$(root, s).forEach(function (e) { e.hidden = !on; }); }

    function update(fromUser, changed) {
      var o = sel();
      var v = find(o);
      if (!v && fromUser && changed != null) {
        // np. "Czarny + Brązowy" istnieje tylko w zestawie: wybierz pierwszy pasujący wariant
        for (var k = 0; k < V.length; k++) {
          if (V[k].options[changed] === o[changed]) { v = V[k]; break; }
        }
        if (v) {
          fields.forEach(function (f, j) {
            $$(f, 'input').forEach(function (i) { i.checked = i.value === v.options[j]; });
          });
          o = v.options.slice();
        }
      }

      fields.forEach(function (f, k) {
        var out = f.querySelector('[data-ta-selected]');
        var c = f.querySelector('input:checked');
        if (out && c) out.textContent = c.value;
        var base = null;
        V.forEach(function (x) { if (units(x.options[k]) === 1 && (base === null || x.price < base)) base = x.price; });
        $$(f, 'input').forEach(function (inp) {
          var t = o.slice(); t[k] = inp.value;
          var tv = find(t) || cheapest(k, inp.value);
          var wrap = inp.closest('[data-ta-choice]');
          if (!wrap) return;
          wrap.classList.toggle('is-off', !find(t));
          var hint = wrap.querySelector('[data-ta-hint]');
          if (hint) {
            // Kolor dostępny tylko w innej opcji (np. w zestawie): podpowiedz, gdzie go znaleźć
            var alt = !find(t) && cheapest(k, inp.value);
            var where = alt ? alt.options.filter(function (x, j) { return j !== k && x !== o[j]; }).join(', ') : '';
            hint.hidden = !where;
            hint.textContent = where ? 'w opcji: ' + where : '';
          }
          var p = wrap.querySelector('[data-ta-pack-price]');
          var u = wrap.querySelector('[data-ta-pack-unit]');
          var s = wrap.querySelector('[data-ta-pack-save]');
          var n = units(inp.value);
          if (p && tv) p.textContent = money(tv.price);
          if (u && tv) u.textContent = n > 1 ? money(Math.round(tv.price / n)) + ' za sztukę' : (tv.compare ? 'zamiast ' + money(tv.compare) : '');
          if (s) {
            var save = (tv && n > 1 && base !== null) ? base * n - tv.price : 0;
            s.hidden = save <= 0;
            s.textContent = save > 0 ? data.saveLabel + ' ' + money(save) : '';
          }
        });
      });

      if (!v) { btn.disabled = true; btnText.textContent = data.strings.unavailable; return; }
      idInput.value = v.id;
      idInput.disabled = !v.available;
      btn.disabled = !v.available;
      btnText.textContent = v.available ? data.strings.add + ' · ' + money(v.price) : data.strings.soldOut;
      var sale = v.compare && v.compare > v.price;
      if (fromUser) $$(root, '[data-ta-price]').forEach(function (e) { e.classList.remove('is-pop'); void e.offsetWidth; e.classList.add('is-pop'); });
      set('[data-ta-price]', money(v.price));
      $$(root, '[data-ta-price]').forEach(function (e) { e.classList.toggle('is-sale', !!sale); });
      show('[data-ta-was]', sale); if (sale) set('[data-ta-was]', money(v.compare));
      show('[data-ta-off]', sale); if (sale) set('[data-ta-off]', '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%');
      show('[data-ta-lowest]', sale); set('[data-ta-lowest-price]', money(v.lowest || v.price));
      set('[data-ta-variant-title]', v.title);
      if (fromUser && v.media && gallery) gallery.toMedia(v.media);
      if (fromUser && data.updateUrl) {
        try { var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); } catch (e) {}
      }
    }

    fields.forEach(function (f, k) { f.addEventListener('change', function () { update(true, k); }); });

    if (sticky) {
      var sb = sticky.querySelector('[data-ta-sticky-add]');
      sb.addEventListener('click', function () {
        if (btn.disabled) { root.scrollIntoView({ behavior: 'smooth' }); return; }
        btn.click();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting); });
        }).observe(btn);
      }
    }
    update(false);
  }

  function initCompare(el) {
    if (el.dataset.taReady) return;
    el.dataset.taReady = '1';
    var r = el.querySelector('input[type=range]');
    if (!r) return;
    function setPos() { el.style.setProperty('--pos', r.value + '%'); }
    r.addEventListener('input', setPos);
    r.addEventListener('pointerdown', function () { el.dataset.taTouched = '1'; });
    r.addEventListener('keydown', function () { el.dataset.taTouched = '1'; });
    setPos();
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    // Jednorazowa podpowiedź ruchu, gdy suwak pojawi się na ekranie
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      var t0 = null;
      function step(ts) {
        if (el.dataset.taTouched) return;
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / 1600);
        r.value = 50 + Math.sin(p * Math.PI * 2) * 22;
        setPos();
        if (p < 1) requestAnimationFrame(step); else { r.value = 50; setPos(); }
      }
      requestAnimationFrame(step);
    }, { threshold: 0.6 });
    io.observe(el);
  }

  // Łagodne pojawianie się treści przy przewijaniu
  var REVEAL = '.ta-sec .ta-h2, .ta-sec .ta-lead, .ta-sec .ta-p, .ta-steps li, .ta-cmp, .ta-unfold__video, .ta-film__frame, .ta-film .ta-btn, .ta-row__media, .ta-row .ta-row__btn, .ta-faq .ta-acc details, .ta-final__media, .ta-final .ta-btn, .ta-final__note';
  var rio = null;
  function initReveal(s) {
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = $$(s, REVEAL);
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    if (!rio) rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) {
      if (e.classList.contains('ta-rv')) return;
      var n = 0, p = e.previousElementSibling;
      while (p && n < 5) { if (p.classList.contains('ta-rv')) n++; p = p.previousElementSibling; }
      e.style.setProperty('--rv-d', n * 90 + 'ms');
      e.classList.add('ta-rv');
      rio.observe(e);
    });
  }

  function init(scope) {
    var s = scope || document;
    initReveal(s);
    $$(s, '[data-ta-buy]').forEach(initBuy);
    $$(s, '[data-ta-cmp]').forEach(initCompare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
